import Tippy from '@tippyjs/react';
import React from 'react';
import './styles.scss';

interface TsrPopoverProps {
    content: React.ReactNode;
    visible: boolean;
    onClickOutside: () => void;
    className?: string;
    contentClassName?: string;
}

export function TsrPopover(props: React.PropsWithChildren<TsrPopoverProps>) {
    return (
        <Tippy
            interactive
            visible={props.visible}
            onClickOutside={() => props.onClickOutside()}
            placement="bottom-end"
            arrow={false}
            offset={[0, 0]}
            duration={0}
            appendTo="parent"
            popperOptions={{ strategy: 'fixed' }}
            content={<div className={`tsr-popover ${props.contentClassName || ''}`}>{props.content}</div>}
        >
            <div className={props.className}>{props.children}</div>
        </Tippy>
    );
}
